import { useSolanaLive } from '../../hooks/useSolanaLive';

function formatTimestamp(value) {
  if (!value) {
    return 'Waiting for data';
  }

  return new Date(value).toLocaleString();
}

function CurrentGameStateViewer() {
  const { currentGamePubkey, currentGameState, error, lastUpdated, loading, subscribed } =
    useSolanaLive();

  return (
    <div className="global-config-viewer">
      <div className="global-config-viewer__metaGrid">
        <div className="surface global-config-viewer__metaCard">
          <span className="label">Current active game pubkey</span>
          <strong className="global-config-viewer__mono">{currentGamePubkey || 'No active game'}</strong>
        </div>

        <div className="surface global-config-viewer__metaCard">
          <span className="label">Loading state</span>
          <strong>{loading.currentGameState ? 'Loading' : 'Ready'}</strong>
        </div>

        <div className="surface global-config-viewer__metaCard">
          <span className="label">Subscribed state</span>
          <strong>{subscribed.currentGameState ? 'Subscribed' : 'Not subscribed'}</strong>
        </div>

        <div className="surface global-config-viewer__metaCard">
          <span className="label">Last updated</span>
          <strong>{formatTimestamp(lastUpdated.currentGameState)}</strong>
        </div>
      </div>

      <div className="surface global-config-viewer__jsonCard">
        <div className="global-config-viewer__jsonHeader">
          <div>
            <p className="eyebrow">Decoded Account</p>
            <h2>current gameState JSON</h2>
          </div>
          {error.currentGameState ? <span className="status-pill status-pill--warning">{error.currentGameState}</span> : null}
        </div>

        <pre className="global-config-viewer__json">
          {JSON.stringify(currentGameState, null, 2) || 'No current gameState data loaded yet.'}
        </pre>
      </div>
    </div>
  );
}

export default CurrentGameStateViewer;
